export default "__VITE_ASSET__BPcPCJiA__"